import React, { useEffect, useRef, useState, useContext } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import currentlocation from "../../assets/Icons/Maps/currentlocation.png";
import paid from "../../assets/Icons/Maps/paid.png";
import unpaid from "../../assets/Icons/Maps/unpaid.png";
import NavigationIcon from "@mui/icons-material/Navigation";
import StoreIcon from "../../assets/Icons/Maps/storefront.png";
import AssetsIcon from "../../assets/Icons/Maps/assetIcon.png";
import {
  Box,
  MenuItem,
  InputLabel,
  styled,
  Select,
  Button,
  Typography,
} from "@mui/material";
import AuthContext from "../../contexts/authContext";

let UnpaidIcon = L.icon({
  iconUrl: unpaid,
  iconSize: [25, 25],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});
let PaidIcon = L.icon({
  iconUrl: paid,
  iconSize: [25, 25],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});
let UserIcon = L.icon({
  iconUrl: currentlocation,
  iconSize: [25, 25],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});
let SIcon = L.icon({
  iconUrl: StoreIcon,
  iconSize: [30, 30],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});
let AssetIcon = L.icon({
  iconUrl: AssetsIcon,
  iconSize: [25, 25],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

const position = [11.098797, 77.3406039];

const StyledSelect = styled(Select)(({ theme }) => ({
  width: "150px",
  height: "35px",
  backgroundColor: "#fff",
  margin: "10px 0px",
  padding: "0px 15px",
  borderRadius: "20px",
}));

const Maps = () => {
  const { userData } = useContext(AuthContext);
  const [userLocation, setUserLocation] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [showMap, setShowMap] = useState(false);
  // const [assetLocations, setAssetLocations] = useState([]);
  const inputRefSchemeStatus = useRef(null);
  const inputRefScheme = useRef(null);
  const inputRefPayment = useRef(null);
  const inputRefArea = useRef(null);
  const user_Id = localStorage.getItem("userId");

  const updateUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => console.error("Error getting user location:", error)
      );
    }
  };

  const handleGetMaps = (e) => {
    e.preventDefault();

    const selectedArea = inputRefArea.current.value;
    const selectedSchemeId = inputRefScheme.current.value;
    const selectedPayment = inputRefPayment.current.value;
    const selectedStatus = inputRefSchemeStatus.current.value;

    let filtered = [...customers];

    // 1️⃣ Area
    if (selectedArea !== "all") {
      filtered = filtered.filter((c) => c.area?._id === selectedArea);
    }

    // 2️⃣ Scheme
    if (selectedSchemeId !== "all") {
      filtered = filtered.filter((c) =>
        c.scheme?.some((cs) => cs.schemeId?._id === selectedSchemeId)
      );
    }

    // 3️⃣ Payment status (paid / unpaid)
    if (selectedPayment !== "all") {
      filtered = filtered.filter((c) =>
        c.scheme.some((cs) => cs.paymentStatus === selectedPayment)
      );
    }

    // 4️⃣ Scheme status (active / completed / cancelled)
    if (selectedStatus !== "all") {
      filtered = filtered.filter((c) => c.status === selectedStatus);
    }
    setFilteredData(filtered);
    setShowMap(true);
  };

  useEffect(() => {
    if (userData?.customers) {
      setCustomers(userData.customers);
    }
    updateUserLocation();
    const locationInterval = setInterval(updateUserLocation, 10000);
    return () => clearInterval(locationInterval);
  }, [userData]);

  return (
    <>
      <Typography
        variant="h5"
        color="#800001"
        sx={{ fontWeight: "400", textAlign: "center", mb: 2 }}
      >
        Maps
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          minHeight: "100%",
          margin: { xs: "5px 10px", sm: "10px 40px" },
          overflow: "hidden",
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 2,
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Box>
                <InputLabel sx={{ color: "#800001" }}>Status</InputLabel>
                <StyledSelect
                  defaultValue="all"
                  inputRef={inputRefSchemeStatus}
                  width={{ xs: "150px", sm: "200px" }}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="completed">Completed</MenuItem>
                  <MenuItem value="cancelled">Cancelled</MenuItem>
                </StyledSelect>
              </Box>

              <Box>
                <InputLabel sx={{ color: "#800001" }}>Scheme</InputLabel>
                <StyledSelect defaultValue="all" inputRef={inputRefScheme}>
                  <MenuItem value="all">All</MenuItem>
                  {userData?.schemes
                    ?.filter((e) => e.status !== "erased")
                    .map((scheme) => (
                      <MenuItem key={scheme._id} value={scheme._id}>
                        {scheme?.schemeName || "Unknown"}
                      </MenuItem>
                    ))}
                </StyledSelect>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <Box>
                <InputLabel sx={{ color: "#800001" }}>Payments</InputLabel>
                <StyledSelect defaultValue="all" inputRef={inputRefPayment}>
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="paid">Paid</MenuItem>
                  <MenuItem value="unpaid">Unpaid</MenuItem>
                </StyledSelect>
              </Box>

              <Box>
                <InputLabel sx={{ color: "#800001" }}>Area</InputLabel>
                <StyledSelect defaultValue="all" inputRef={inputRefArea}>
                  <MenuItem value="all">All</MenuItem>
                  {/* {userData?.users
                  ?.forEach((ie) => ie.areas)
                  .map((area) => (
                    <MenuItem value={area._id} key={area._id}>
                      {area?.areaName || "Unknown"}
                    </MenuItem>
                  ))}
                   */}
                  {/* If users area is "All", then it should display from userData.areas or from users */}

                  {userData.users
                    ?.filter((user) => user._id === user_Id)[0]
                    ?.areas.map((area) => (
                      <MenuItem value={area._id} key={area._id}>
                        {area?.areaName || "Unknown"}
                      </MenuItem>
                    ))}
                </StyledSelect>
              </Box>
            </Box>

            <Box sx={{ mt: 2 }}>
              <Button
                onClick={handleGetMaps}
                sx={{
                  backgroundColor: "#800001",
                  color: "#fff",
                  height: "35px",
                  alignSelf: "flex-end",
                  "&:hover": {
                    backgroundColor: "#800001",
                    color: "#fff",
                  },
                }}
              >
                View
              </Button>
            </Box>
          </Box>
        </Box>

        {showMap && (
          <MapContainer
            center={position}
            zoom={12}
            style={{ height: "500px", zIndex: 1, marginBottom: "20px" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

            {filteredData.map((marker, index) => (
              <Marker
                key={index}
                position={[marker.lat || 0, marker.long || 0]}
                icon={marker.paymentStatus === "paid" ? PaidIcon : UnpaidIcon}
              >
                <Popup>
                  {marker.name}
                  <br />
                  {marker.mobile} |{" "}
                  {marker.scheme[0]?.SchemeId?.schemeName || ""} <br />
                  {marker.address}
                  <Box sx={{ textAlign: "center", margin: "10px" }}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.google.com/maps/dir/${marker.lat},${marker.long}/${userLocation?.lat},${userLocation?.lng}/@16z`}
                    >
                      <NavigationIcon />
                    </a>
                  </Box>
                </Popup>
              </Marker>
            ))}
            {/* ASSET MARKERS */}
            {userData?.assets?.map((asset, aIndex) =>
              asset.designs?.map((design, dIndex) =>
                design.lat && design.long ? (
                  <Marker
                    key={`asset-${aIndex}-${dIndex}`}
                    position={[design.lat, design.long]}
                    icon={AssetIcon}
                  >
                    <Popup>
                      <Typography sx={{ color: "#800001" }}>
                        {design.designName || "Asset"}
                        <br />
                        {design.designId || ""} - {design.assetType || ""}
                      </Typography>

                      <Box sx={{ textAlign: "center", margin: "10px" }}>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`https://www.google.com/maps/dir/${design.lat},${design.long}/${userLocation?.lat},${userLocation?.lng}/@16z`}
                        >
                          <NavigationIcon sx={{ color: "#800001" }} />
                        </a>
                      </Box>
                    </Popup>
                  </Marker>
                ) : null
              )
            )}

            {userLocation && (
              <Marker position={userLocation} icon={UserIcon}>
                <Popup>Your current location</Popup>
              </Marker>
            )}
            <Marker position={[11.11994 || 0, 77.340424 || 0]} icon={SIcon}>
              <Popup>
                <Typography sx={{ color: "#800001" }}>
                  Sakthi Jeweller
                </Typography>
                <Box sx={{ textAlign: "center", margin: "10px" }}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://www.google.com/maps/dir/11.119940,77.340424/${userLocation?.lat},${userLocation?.lng}/@16z`}
                  >
                    <NavigationIcon sx={{ color: "#800001" }} />
                  </a>
                </Box>
              </Popup>
            </Marker>
          </MapContainer>
        )}
      </Box>
    </>
  );
};

export default Maps;
